module.exports = __webpack_public_path__ + "static/img/Shixi.3cc2cebb.png";